import { useState } from 'react';
import { api } from '@/lib/api-client';
import { Button } from '@/components/ui/button';
import { CreditCard } from 'lucide-react';

export function PortalButton({
    label = 'Manage Payment Methods',
}: {
    label?: string;
}) {
    const [loading, setLoading] = useState(false);

    const openPortal = async () => {
        setLoading(true);
        try {
            const res = await api.post('/billing/portal/session', {
                return_url: window.location.href,
            });
            if (res.data.url) window.location.href = res.data.url;
        } catch (err) {
            console.error('PortalButton.openPortal: failed', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button variant="outline" onClick={openPortal} disabled={loading}>
            <CreditCard className="w-4 h-4 mr-2" />
            {loading ? 'Opening...' : label}
        </Button>
    );
}
